import type { ChangeEvent, CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { iconLeaderboardSearch } from '../../assets';
import { useTheme } from '../../theme';

const SEARCH_INPUT_CLASS = 'admin-leaderboard-search-field';

export interface LeaderboardSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function LeaderboardSearchBar({
  value,
  onChange,
  placeholder,
}: LeaderboardSearchBarProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const lb = theme.palette.adminLeaderboard;

  const ph = placeholder ?? t('leaderboard.search.placeholder');

  const outer: CSSProperties = {
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: 320,
    backgroundColor: lb.searchBarOuterBackground,
    border: `${theme.shape.borderWidth.thin} solid ${lb.searchBarOuterBorder}`,
    borderRadius: lb.searchBarOuterBorderRadius,
    padding: lb.searchBarOuterPadding,
  };

  const inner: CSSProperties = {
    boxSizing: 'border-box',
    width: '100%',
    minHeight: lb.searchBarMinHeight,
    backgroundColor: lb.searchBarBackground,
    borderRadius: lb.searchBarBorderRadius,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm2,
    paddingLeft: lb.searchBarPaddingX,
    paddingRight: lb.searchBarPaddingX,
  };

  return (
    <div style={outer}>
      <style>{`.${SEARCH_INPUT_CLASS}::placeholder { color: ${lb.searchPlaceholderText}; }`}</style>
      <div style={inner}>
        <img
          src={iconLeaderboardSearch}
          alt=""
          width={lb.searchIconSize}
          height={lb.searchIconSize}
          style={{ display: 'block', flexShrink: 0, objectFit: 'contain' }}
          aria-hidden
        />
        <input
          type="search"
          className={SEARCH_INPUT_CLASS}
          value={value}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onChange(e.target.value)
          }
          placeholder={ph}
          aria-label={ph}
          style={{
            flex: 1,
            minWidth: 0,
            minHeight: lb.searchBarMinHeight - 8,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            fontSize: theme.typography.fontSize.base,
            fontFamily: theme.typography.fontFamily,
            color: lb.searchInputText,
          }}
        />
      </div>
    </div>
  );
}
